import React from 'react';
import { Modal } from 'react-bootstrap';

type CaptainModalProps = {
    isOpen: boolean;
    onClose: () => void;
    children?: React.ReactNode;
    style?: React.CSSProperties;
};

const CaptainModal: React.FC<CaptainModalProps> = ({
    isOpen,
    onClose,
    children,
    style,
}) => {
    return (
        <Modal show={isOpen} onHide={onClose} centered style={style ?? {}}>
            <Modal.Header closeButton className="border-0" />
            <Modal.Body className="d-flex flex-column gap-2 pt-0 shadow">
                {children}
            </Modal.Body>
        </Modal>
    );
};

export default CaptainModal;
